import Vue from "vue";

Vue.component("global-header", require("./pages/components/header.vue").default);
Vue.component("global-left", require("./pages/components/left.vue").default);
Vue.component("global-sidebar", require("./pages/components/sidebar").default);

Vue.component("global-footer", require("./pages/components/footer.vue").default);

Vue.component("white-space", require("./pages/_widget/WhiteSpace.vue").default);

Vue.component("Empty", require("./pages/_widget/Empty").default);

//省份城市二级
Vue.component("ProvinceCity", require("./pages/_widget/ProvinceCity").default);

//购物车
Vue.component("CartBalls", require("./pages/_widget/CartBalls").default);
